export const deploymentTypes = {
    SET_DEPLOYMENT_MODE: 'SET_DEPLOYMENT_MODE',
    SET_DEPLOYMENT_APP_NAME: 'SET_DEPLOYMENT_APP_NAME',
}
